import { Box, Link } from "@mui/material";
import mailIcon from "../assets/icons/mail.png";

export const SupportEmail = () => {
	return (
		<Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
			<img src={mailIcon} alt="Support Email" height={21} width={21} />
			<Link
				href="mailto:support@cargoseller.pl"
				variant="body2"
				underline="hover"
				color="inherit"
			>
				support@cargoseller.pl
			</Link>
		</Box>
	);
};
